// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width:767px){.btn.main[data-v-22377d7d]{padding:16px 24px}}", ""]);
// Exports
module.exports = exports;
